/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ManagerControllerDtoManagerViewRequest model module.
 * @module model/ManagerControllerDtoManagerViewRequest
 * @version 1.0
 */
class ManagerControllerDtoManagerViewRequest {
    /**
     * Constructs a new <code>ManagerControllerDtoManagerViewRequest</code>.
     * @alias module:model/ManagerControllerDtoManagerViewRequest
     * @param managerNo {Number} 
     */
    constructor(managerNo) { 
        
        ManagerControllerDtoManagerViewRequest.initialize(this, managerNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, managerNo) { 
        obj['managerNo'] = managerNo;
    }

    /**
     * Constructs a <code>ManagerControllerDtoManagerViewRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManagerControllerDtoManagerViewRequest} obj Optional instance to populate.
     * @return {module:model/ManagerControllerDtoManagerViewRequest} The populated <code>ManagerControllerDtoManagerViewRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManagerControllerDtoManagerViewRequest();

            if (data.hasOwnProperty('managerNo')) {
                obj['managerNo'] = ApiClient.convertToType(data['managerNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManagerControllerDtoManagerViewRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManagerControllerDtoManagerViewRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ManagerControllerDtoManagerViewRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

ManagerControllerDtoManagerViewRequest.RequiredProperties = ["managerNo"];

/**
 * @member {Number} managerNo
 */
ManagerControllerDtoManagerViewRequest.prototype['managerNo'] = undefined;






export default ManagerControllerDtoManagerViewRequest;

